export default "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?e9db4005489e24809b62e61177c543a8";